import { motion } from 'framer-motion';

/** Animated SVG donut with a centre total and a legend. */
export default function DonutChart({ data, size = 180, thickness = 20 }) {
  const total = data.reduce((s, d) => s + d.value, 0);
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  const cx = size / 2;
  const cy = size / 2;
  let acc = 0;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
      <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} className="flex-none max-w-full h-auto mx-auto sm:mx-0">
        <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(127,127,127,0.18)" strokeWidth={thickness} />
        {total > 0 &&
          data.map((d) => {
            const frac = d.value / total;
            if (!frac) return null;
            const dash = frac * c;
            const rot = acc * 360 - 90;
            acc += frac;
            return (
              <motion.circle
                key={d.label}
                cx={cx}
                cy={cy}
                r={r}
                fill="none"
                stroke={d.color}
                strokeWidth={thickness}
                strokeLinecap="round"
                strokeDasharray={`${dash} ${c}`}
                transform={`rotate(${rot} ${cx} ${cy})`}
                initial={{ strokeDashoffset: dash }}
                animate={{ strokeDashoffset: 0 }}
                transition={{ duration: 1, ease: [0.2, 0.8, 0.2, 1] }}
                style={{ filter: `drop-shadow(0 0 6px ${d.color}66)` }}
              />
            );
          })}
        <text x={cx} y={cy - 2} textAnchor="middle" fontWeight="800" fontSize="30" fill="var(--ink)">{total}</text>
        <text x={cx} y={cy + 18} textAnchor="middle" fontSize="11" fill="var(--ink-soft)" letterSpacing="1">JOBS</text>
      </svg>

      <div className="grid gap-2 w-full sm:w-auto sm:min-w-[150px]">
        {data.map((d) => (
          <div key={d.label} className="flex items-center gap-2 text-sm text-ink">
            <span className="h-2.5 w-2.5 rounded" style={{ background: d.color, boxShadow: `0 0 8px ${d.color}` }} />
            <span className="flex-1">{d.label}</span>
            <span className="font-semibold" style={{ color: d.color }}>{d.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
